export var createMap = function createMap() {
  return Object.create(null);
};